"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Facebook, Instagram, Linkedin, Twitter, ArrowUp } from "lucide-react";
import { cn } from "@/lib/utils";
export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  const currentYear = new Date().getFullYear();
  const reviewsUrl = typeof window !== "undefined" && window.location.hostname === "studiomess.it" ? "https://studiomess.it/?embed_recensioni" : "https://mesuraca-ingegneria-sicura-1773480672.megify.it/?embed_recensioni";
  const socialLinks = [{
    icon: Facebook,
    href: "https://www.facebook.com/studiomesssrl/",
    label: "Facebook"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com/company/fmchimica",
    label: "LinkedIn"
  }, {
    icon: Instagram,
    href: "https://www.instagram.com/studiomesssrl/",
    label: "Instagram"
  }];
  const quickLinks = [{
    label: "Home",
    href: "/HomePage"
  }, {
    label: "Studio",
    href: "/StudioPage"
  }, {
    label: "Servizi",
    href: "/ServicesPage"
  }, {
    label: "Formazione",
    href: "/TrainingPage"
  }];
  const legalLinks = [{
    label: "News/Normative",
    href: "/NewsRegulationsPage"
  }, {
    label: "Privacy Policy",
    href: "#"
  }, {
    label: "P.IVA 11500510968",
    href: "#"
  }];
  return <section data-section-id="47484" id="piè-di-pagina" className="dark bg-primary text-primary-foreground">

      {/* === SEZIONE RECENSIONI === */}
      <div id="recensioni" className="bg-background text-foreground relative overflow-hidden py-20">
        <div className="absolute inset-0 pointer-events-none z-0" style={{
        backgroundImage: `linear-gradient(to right, var(--border) 1px, transparent 1px), linear-gradient(to bottom, var(--border) 1px, transparent 1px)`,
        backgroundSize: "50px 50px",
        opacity: 0.15
      }} aria-hidden="true" />
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary/20 border border-border/50 w-fit mx-auto mb-6 backdrop-blur-sm">
              <span className="w-2 h-2 rounded-full bg-accent animate-pulse" />
              <span className="text-xs font-medium tracking-wider uppercase text-muted-foreground">
                Cosa dicono di noi
              </span>
            </div>
            <h2 className="font-black tracking-tighter text-foreground font-sans text-3xl md:text-4xl mb-4">
              Recensioni dei Nostri Clienti
            </h2>
            <p className="text-muted-foreground max-w-xl mx-auto text-lg font-light">
              La fiducia dei nostri clienti è il nostro miglior biglietto da visita.
            </p>
          </div>
          <div className="max-w-4xl mx-auto">
            <iframe src={reviewsUrl} title="Recensioni Google Studio MESS" className="w-full border-0" style={{
            minHeight: "500px",
            background: "transparent"
          }} loading="lazy" sandbox="allow-scripts allow-same-origin allow-popups" />
          </div>
        </div>
      </div>

      {/* === FOOTER === */}
      <div className="py-12 md:py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
            <div className="flex flex-col gap-6">
              <h3 className="text-lg font-bold tracking-tight uppercase font-sans !text-[hsl(221,39%,11%)]">Studio MESS S.r.l.</h3>
              <div className="flex flex-col gap-3 text-sm text-secondary-foreground/70 font-sans">
                <p className="font-mono text-xs">P.IVA: 11500510968</p>
                <div className="flex flex-col gap-1">
                  <span className="font-semibold text-secondary-foreground/90">Indirizzo:</span>
                  <a href="https://www.google.com/maps/dir//Via+Montello,+snc,+20861+Brugherio+MB" target="_blank" rel="noopener noreferrer" className="hover:text-accent transition-colors">
                    <span>Via Montello, snc</span>
                    <br />
                    <span>20861 Brugherio (MB)</span>
                  </a>
                </div>
                <div className="flex items-center gap-2">
                  <span className="font-semibold text-secondary-foreground/90">Tel:</span>
                  <a href="tel:0399050588" className="hover:text-accent transition-colors">039 905 0588</a>
                </div>
                <a href="https://wa.me/3479009283?text=Ciao%20Studio%20Mess%2C%20vorrei%20maggiori%20informazioni%20sui%20vostri%20servizi." target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-green-600 hover:text-green-500 transition-colors w-fit mt-1">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                  </svg>
                  Scrivici su WhatsApp
                </a>
              </div>
            </div>
            <div className="flex flex-col gap-6">
              <h3 className="text-lg font-bold tracking-tight uppercase font-sans !text-[hsl(221,39%,11%)]">NAVIGAZIONE</h3>
              <nav className="flex flex-col gap-3">
                {quickLinks.map((link, i) => <Link key={i} data-index={i} to={link.href} className="text-secondary-foreground/70 hover:text-accent transition-colors w-fit text-sm font-sans">{link.label}</Link>)}
              </nav>
            </div>
            <div className="flex flex-col gap-6">
              <h3 className="text-lg font-bold tracking-tight uppercase font-sans !text-[hsl(0,0%,0%)]">Legale & Social</h3>
              <nav className="flex flex-col gap-3">
                {legalLinks.map((link, i) => <Link key={i} data-index={i} to={link.href} className="text-secondary-foreground/70 hover:text-accent transition-colors w-fit text-sm font-mono">{link.label}</Link>)}
              </nav>
              <div className="flex gap-4 mt-2">
                {socialLinks.map((social, i) => {
                const Icon = social.icon;
                return <Link key={i} data-index={i} to={social.href} className="text-secondary-foreground/70 hover:text-accent transition-colors p-2 hover:bg-secondary/20 rounded-none border border-transparent hover:border-border" aria-label={social.label}>
                    <Icon className="h-5 w-5" />
                  </Link>;
              })}
              </div>
            </div>
          </div>
          <Separator className="bg-border/20 mb-8" />
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-secondary-foreground/60 font-mono tracking-wider">
            <p>&copy; {currentYear} Studio MESS S.r.l. Tutti i diritti riservati. Ingegneria e Sicurezza.</p>
            <Button variant="ghost" size="sm" onClick={scrollToTop} className="text-secondary-foreground/60 hover:text-foreground hover:bg-secondary/20 gap-2 rounded-none border border-border/10">
              Torna su <ArrowUp className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </section>;
}